import { binaryToBase64 } from './../../../../utils/utf8.js';
import { dataToExecData, ExecArgBase } from '../ExecArgBase.js';
/**
 * @category Contract Exec Arguments
 */
export default class ExecArgInitiateTransfer extends ExecArgBase {
    static fromJSON(params) {
        return new ExecArgInitiateTransfer(params);
    }
    toData() {
        const { params } = this;
        return {
            nonce: Math.round(Math.random() * 100000),
            asset: {
                amount: params.amount,
                info: params.info,
            },
            recipient_chain: params.recipientChainId,
            recipient: binaryToBase64(params.recipient),
            fee: params.relayerFee || '0',
            ...(params.payload && { payload: binaryToBase64(params.payload) }),
        };
    }
    toExecData() {
        const data = this.toData();
        const action = data.payload
            ? 'initiate_transfer_with_payload'
            : 'initiate_transfer';
        return dataToExecData(action, this.toData());
    }
}
